import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Pos } from '@shop/const';

@Component({
  selector: 'sd-pickup-shop-list-desktop-list',
  templateUrl: './pickup-shop-list-desktop-list.component.html',
  styleUrls: ['./pickup-shop-list-desktop-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPickupShopListDesktopListComponent {
  @Input() shops: Pos[];

  @Output() shopClick = new EventEmitter<string>();

  onShopClick(name: string): void {
    this.shopClick.emit(name);
  }
}
